<template>
  <el-dropdown trigger="click" @command="handleActions">
    <el-button
      type="primary"
      plain
      icon="el-icon-refresh-right"
      data-qa="segment-evaluate-dropdown"
    >
      {{ $t('Audiences_Segment_Dropdown_Evaluate') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        command="calculateSizeUsers"
        icon="el-icon-user"
        data-qa="count-users-option"
      >
        {{ $t('Audiences_Segment_Action_CountUsers') }}
      </el-dropdown-item>

      <el-dropdown-item
        command="calculateSizeDevices"
        icon="el-icon-mobile-phone"
        data-qa="count-devices-option"
      >
        {{ $t('Audiences_Segment_Action_CountDevices') }}
      </el-dropdown-item>

      <el-dropdown-item
        command="channelsReach"
        icon="el-icon-s-promotion"
        data-qa="count-channels-option"
      >
        {{ $t('Audiences_Segment_Action_CountRecipients') }}
      </el-dropdown-item>

      <el-dropdown-item
        command="usersPreview"
        icon="el-icon-view"
        v-if="$can('UserPersonalData::Read') && !$isRole('csa')"
        data-qa="preview-users-option"
      >
        {{ $t('Audiences_Segment_Action_MembersPreview') }}
      </el-dropdown-item>

      <el-dropdown-item
        command="exportMembers"
        icon="el-icon-download"
        v-if="$can('UserPersonalData::Export')"
        data-qa="export-users-option"
      >
        {{ $t('Audiences_Segment_Action_Export_Members') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { EventBus } from '@/core/EventBus'
export default {
  props: {
    segment: {
      required: true,
      type: Object
    }
  },
  methods: {
    handleActions(action) {
      switch (action) {
        case 'calculateSizeUsers':
          EventBus.$emit('calculate-size-show', 'users', true)
          break
        case 'calculateSizeDevices':
          EventBus.$emit('calculate-size-show', 'devices', true)
          break
        case 'usersPreview':
          EventBus.$emit('members-preview-show')
          break
        case 'channelsReach':
          EventBus.$emit('channels-reach-configure')
          break
        case 'exportMembers':
          EventBus.$emit('export-members-show')
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/SegmentEvaluateDropdown.vue